import { render, staticRenderFns } from "./MenahalAudioLibrary.vue?vue&type=template&id=589aba8a&"
import script from "./MenahalAudioLibrary.vue?vue&type=script&lang=js&"
export * from "./MenahalAudioLibrary.vue?vue&type=script&lang=js&"
import style0 from "./MenahalAudioLibrary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports